import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as QRCode from 'qrcode-generator';

@Component({
  selector: 'app-template-standard',
  templateUrl: './template-standard.component.html',
  styleUrls: ['./template-standard.component.css'],
})
export class TemplateStandardComponent implements OnInit, OnChanges {
  // Template ka naam (badge mein dikhta hai)
  @Input() templateName: string = 'Standard Digital Card';

  // Baqi templates jaisi hi @Input() list (create-card-steps ke saath compatible)
  @Input() buttonColor: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() companyName: string;
  @Input() jobTitle: string;
  @Input() content: string;
  @Input() email: string;

  @Input() linkedin: string;
  @Input() youtube: string;
  @Input() twitter: string;
  @Input() facebook: string;
  @Input() instagram: string;
  @Input() pinterest: string;
  @Input() gpa: string;
  @Input() age: string;
  @Input() weight: string;
  @Input() height: string;
  @Input() school: string;
  @Input() grade: string;

  @Input() address: string;
  @Input() phone: string;
  @Input() phoneAllow: boolean;
  @Input() forwardCard: boolean;
  @Input() saveCard: boolean;
  @Input() inviteCode: boolean;
  @Input() referal: any;
  @Input() photo: File;
  @Input() logo: File;
  @Input() buttons: Array<{ LinkButtonLink: string; LinkButtonTitle: string }>;
  @Input() umyotubeArray: any;
  @Input() vimeoArray: any;
  @Input() youtubeArray: any;
  @Input() productImages: any = ['assets/images/app-devices.jpg'];

  qrCodeImage: SafeResourceUrl | null = null;
  imageSrc: string | ArrayBuffer | null = 'assets/images/john-doe-avatar.jpg';
  imageSrcLogo: string | ArrayBuffer | null = 'assets/images/unmasking-yourself.jpg';

  constructor(private sanitizer: DomSanitizer, private router: Router) {}

  ngOnInit(): void {
    this.generateQRCode();
  }

  generateQRCode() {
    const url = window.location.href;
    const qr = QRCode(0, 'L');
    qr.addData(url);
    qr.make();
    const qrImageTag = qr.createImgTag(5);
    const div = document.createElement('div');
    div.innerHTML = qrImageTag;
    const img = div.firstChild as HTMLImageElement;
    this.qrCodeImage = this.sanitizer.bypassSecurityTrustResourceUrl(img.src);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photo']) {
      this.loadImage();
    }
    if (changes['logo']) {
      this.loadImageLogo();
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  /** link ka domain (www. ke baghair), jaise "umyo.com" */
  hostOf(url: string): string {
    if (!url) { return ''; }
    try {
      return new URL(/^https?:\/\//i.test(url) ? url : 'https://' + url).hostname.replace(/^www\./, '');
    } catch (e) {
      return url;
    }
  }

  private loadImage(): void {
    if (this.photo instanceof File) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.imageSrc = event.target?.result as string;
      };
      reader.readAsDataURL(this.photo);
    } else if (typeof this.photo === 'string' && this.photo) {
      this.imageSrc = this.photo;
    }
  }

  private loadImageLogo(): void {
    if (this.logo instanceof File) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.imageSrcLogo = event.target?.result as string;
      };
      reader.readAsDataURL(this.logo);
    } else if (typeof this.logo === 'string' && this.logo) {
      this.imageSrcLogo = this.logo;
    }
  }

  navigateToHome(): void {
    localStorage.clear();
    const referralId = this.referal || '';
    this.router.navigate(['/'], { queryParams: { referralId } });
  }

  downloadVCard(): void {
    const vCardData = `BEGIN:VCARD
VERSION:3.0
FN:${this.firstName} ${this.lastName}
ORG:${this.companyName}
EMAIL:${this.email}
TEL:${this.phone}
ADR:${this.address}
END:VCARD`;
    const blob = new Blob([vCardData], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'contact.vcf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}